<template>
  <form
    action="/api/quotation"
    id="form_car"
    class="mt-30"
    method="POST"
    @submit="handleSubmit"
    ref="classicCar"
  >
    <input type="hidden" name="quotation_id" :value="quotationId" />
    <input type="hidden" name="quotation_type" :value="type" />
    <classic-car-container :infocar="infocar"></classic-car-container>
    <div class="text-align-center container">
      <div class="container-general">
        <button
          class="button-primary mw-350"
          type="submit"
          :disabled="loading"
          title="Calcola Quotazione"
          data-event-click="quotauto.ruoteclassiche.click"
          data-event-imps="quotauto.ruoteclassiche.imps"
          ref="classicButton"
        >
          <span v-if="!loading">Calcola quotazione</span>
          <loader v-else size="20px"></loader>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Loader from './Loader.vue';
import ClassicCarContainer from './ClassicCarContainer.vue';

export default {
  name: 'ClassicCarData',
  components: {
    Loader,
    ClassicCarContainer,
  },
  props: {
    quotationId: {
      type: Number,
      required: true,
    },
    infocar: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleSubmit(event) {
      this.loading = true;
      this.onClassicClick();
    },
    onClassicClick() {
      const clickEvent = 'quotauto.ruoteclassiche.click';
      if (
        window &&
        window.webtrekk_funcs &&
        typeof window.webtrekk_funcs.trackWebtrekkEvent === 'function'
      ) {
        window.webtrekk_funcs.trackWebtrekkEvent(clickEvent);
        window.webtrekk_funcs.sendWebtrekkEvents();
      }

    },
    setupViewportTracking() {
      if (!('IntersectionObserver' in window)) return;

      const options = {
        root: null,
        threshold: 0.5, // almeno metà visibile
      };

      const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const impsEvent = el.dataset.eventImps;

            if (
              impsEvent &&
              window &&
              window.webtrekk_funcs &&
              typeof window.webtrekk_funcs.trackWebtrekkEvent === 'function'
            ) {
              window.webtrekk_funcs.trackWebtrekkEvent(impsEvent);
              window.webtrekk_funcs.sendWebtrekkEvents();

              observerInstance.unobserve(el); // tracciato una volta sola
            }
          }
        });
      }, options);

      if (this.$refs.classicButton) {
        observer.observe(this.$refs.classicButton);
      }
    }
  },
    mounted() {
        this.$nextTick(() => {
        this.setupViewportTracking();
        });
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/ClassicCarData.vue